import React,{useState} from "react";
import { Link } from "react-router-dom";
// import { ChevronRight } from "lucide-react";
import { CheckCircle, ChevronRight,Building2, Calendar, Mail, Phone, Rocket, X,User  } from "lucide-react";
import { saveStartupIdeaWithoutPayment } from "../../utils/api";
import toast from "react-hot-toast";
const StudentAmbassoderPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
  const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",

  college: "",
  cityAndState: "",
  programDepartmentYear: "",
  graduationYear: "",

  isFounder: "",
  leadershipBackground: "",

  whyAmbassador: "",
  primaryContact: "",
  sixMonthCommitment: "",

  linkedInProfile: "",
  cvFile: null,

  declarationAccepted: false,

  programType: "student-ambassador"
})
  const [currentStep, setCurrentStep] = useState(1)
      const [isSubmitting, setIsSubmitting] = useState(false)
    
      const [processing, setProcessing] = useState(false);
      
    
    const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

    const handleSubmit = async (e) => {
  setProcessing(true);

  try {
    // 1. Validate inputs
    if (!formData.name || !formData.phone || !formData.email) {
      toast.error("Please fill all required fields");
      setProcessing(false);
      return;
    }

    let payload = { ...formData };

    // 2. Convert CV file to Base64 IF exists
    if (formData.cvFile) {
      const base64CV = await fileToBase64(formData.cvFile);

      payload.cvFile = base64CV; // ✅ store base64 string
      payload.cvFileName = formData.cvFile.name;
      payload.cvFileType = formData.cvFile.type;
    }

    // 3. Send to backend
    const response = await saveStartupIdeaWithoutPayment(payload);

    toast.success(response.message);
    setIsModalOpen(false);

    // 4. Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",

      college: "",
      cityAndState: "",
      programDepartmentYear: "",
      graduationYear: "",

      isFounder: "",
      leadershipBackground: "",

      whyAmbassador: "",
      primaryContact: "",
      sixMonthCommitment: "",

      linkedInProfile: "",
      cvFile: null,

      declarationAccepted: false,
      programType: "student-ambassador"
    });

    setCurrentStep(1);

  } catch (error) {
    console.error("Something went wrong:", error);
    toast.error(error.message || "Something went wrong");
  } finally {
    setProcessing(false);
    setIsSubmitting(false);
  }
};

  return (
    <>
      {/* -------------------------------------- */}
      {/* WHAT IS PROGRAM */}
      {/* -------------------------------------- */}
          <section className="py-10 px-6 md:px-20">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            
            {/* LEFT CONTENT */}
            <div className="order-2 md:order-1">
              <h2 className="text-4xl font-extrabold text-gray-900 mb-6">
                  What is the TACTOS <br /><span className="text-[#fd3e3d]">   Student Ambassador Program?</span>
              </h2>
        
              <p className="text-gray-700 text-lg max-w-xl leading-relaxed mb-10 text-justify">
               A leadership initiative designed to empower students to become the bridge between TACTOS and their institution. Ambassadors represent TACTOS inside their campus and gain exclusive training, mentorship, and opportunities to lead real activities.
              </p>
               <div className="text-center">
          <button
           onClick={()=>setIsModalOpen(true)}
            className="inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-4 px-10 rounded-xl shadow-lg hover:shadow-xl transition w-full justify-center"
          >
            Apply Now
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
        
            
            </div>
        
            {/* RIGHT IMAGE */}
            <div className="order-1 md:order-2 flex justify-center md:justify-end">
              <img
                src="/studentambpagenew.png"
                alt="Bootcamp"
                className="rounded-xl w-full max-w-md"
              />
            </div>
        
          </div>
        </section>
   

      {/* -------------------------------------- */}
      {/* ELIGIBILITY */}
      {/* -------------------------------------- */}
      {/* -------------------------------------- */}
{/* ELIGIBILITY – Arrow Cards */}
{/* -------------------------------------- */}
<section className="py-10 px-6 md:px-20 bg-gray-50">
  <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-14 tracking-wide">
    ELIGIBILITY <span className="text-[#fd3e3d]">CRITERIA</span>
  </h2>

  <div className="space-y-10 max-w-6xl mx-auto">

    <div className="flex flex-col md:flex-row justify-center gap-6">
      {[
        [
          "Student Startup Founder",
          "Must be a 3rd-year student building or running a startup."
        ],
        [
          "Commitment Required",
          "Must commit a minimum of 6 months to the ambassador program."
        ],
        [
          "Running a Startup",
          "Should be actively involved in a startup or innovation project."
        ],
      ].map(([title, desc], i,arr) => (
        <div
          key={i}
          className="relative w-full md:w-[32%] border p-6 rounded-xl bg-white shadow-sm"
        >
          <h3 className="text-xl font-bold mb-2">{title}</h3>
          <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

          {/* Red Arrow */}
          {i !== arr.length - 1 && (
        <div
          className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
        ></div>
      )}
        </div>
      ))}
    </div>

    <div className="flex flex-col md:flex-row justify-center gap-6">
      {[
        [
          "Motivated to Lead",
          "Must be enthusiastic about hosting startup events & campus activities."
        ],
        [
          "Passionate About Community",
          "Should show genuine interest in leadership, startups, or community building."
        ],
      ].map(([title, desc], i,arr) => (
        <div
          key={i}
          className="relative w-full md:w-[34%] border p-6 rounded-xl bg-white shadow-sm"
        >
          <h3 className="text-xl font-bold mb-2">{title}</h3>
          <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

          {/* Red Arrow */}
         {i !== arr.length - 1 && (
        <div
          className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
        ></div>
      )}
        </div>
      ))}
    </div>

  </div>
</section>


      {/* -------------------------------------- */}
      {/* HOW IT WORKS – Residency Style */}
      {/* -------------------------------------- */}
      <section className="py-10 px-6 md:px-20 bg-white">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-14 tracking-wide">
          HOW <span className="text-[#fd3e3d]">IT WORKS</span>
        </h2>

        <div className="space-y-10">

          {/* Row 1 */}
          <div className="flex flex-col md:flex-row justify-center gap-6">
            {[
              [
                "Register Now",
                "Apply to become a TACTOS Student Ambassador and unlock exclusive opportunities.",
              ],
              [
                "Screening / Proving",
                "Showcase your mindset, passion, and leadership potential for the ambassador role.",
              ],
              [
                "Your Calling",
                "Begin your journey with meaningful responsibilities, activities, and leadership roles.",
              ],
            ].map(([title, desc], i,arr) => (
              <div
                key={i}
                className="relative w-full md:w-[32%] border p-6 rounded-xl bg-white shadow-sm"
              >
                <h3 className="text-xl font-bold mb-2">{title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

                {/* Arrow Shape */}
               {i !== arr.length - 1 && (
        <div
          className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
        ></div>
      )}
              </div>
            ))}
          </div>

          {/* Row 2 */}
          <div className="flex flex-col md:flex-row justify-center gap-6">
            {[
              [
                "Campus-Level Execution",
                "Lead events, workshops, startup activities, and innovation-driven programs on campus.",
              ],
              [
                "Grow as a Leader",
                "Gain mentorship, sharpen leadership skills, and build a strong innovation ecosystem.",
              ],
            ].map(([title, desc], i,arr) => (
              <div
                key={i}
                className="relative w-full md:w-[34%] border p-6 rounded-xl bg-white shadow-sm"
              >
                <h3 className="text-xl font-bold mb-2">{title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

                {/* Arrow Shape */}
               {i !== arr.length - 1 && (
        <div
          className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
        ></div>
      )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* -------------------------------------- */}
      {/* ROLES & RESPONSIBILITIES */}
      {/* -------------------------------------- */}
      <section className="py-10 px-6 md:px-20 bg-gray-50">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-14 tracking-wide">
          ROLES & <span className="text-[#fd3e3d]">RESPONSIBILITIES</span>
        </h2>

        <div className="space-y-6 max-w-6xl mx-auto">
          {[
            ["Promote Entrepreneurship", "Introduce students to TACTOS programs, cohorts, and events that are happening"],
            ["Lead Campus Activities", "Organize workshops, bootcamps, idea contests, startup roasts, and many programs on campus"],
            ["Build Startup Communities", "Form TACTOS student entrepreneur clubs & lead innovation groups in the campus"],
            ["Identify Talent", "Spot promising founders and connect them to TACTOS"],
            ["Support Events", "Coordinate with TACTOS for on-ground execution of programs"],
            ["Share Campus Insights", "Act as the voice of your college’s entrepreneurship ecosystem"],
          ].map(([title, desc], i) => (
            <div
              key={i}
              className="border rounded-full bg-white py-6 px-10 shadow-sm hover:shadow-md transition text-center"
            >
              <h4 className="font-semibold text-lg">{title}</h4>
              <p className="text-gray-600 text-sm mt-1">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* -------------------------------------- */}
      {/* BENEFITS */}
      {/* -------------------------------------- */}
     {/* -------------------------------------- */}
{/* BENEFITS – Arrow Cards */}
{/* -------------------------------------- */}
<section className="py-10 px-6 md:px-20 bg-white">
  <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-14 tracking-wide">
    BENEFITS <span className="text-[#fd3e3d]">YOU GET</span>
  </h2>

  <div className="space-y-10 max-w-6xl mx-auto">

    {/* Row 1 */}
    <div className="flex flex-col md:flex-row justify-center gap-6">
      {[
        [
          "Access to TACTOS Dashboards",
          "Get exclusive access to the official Startup Dashboard."
        ],
        [
          "Business Consultation Wing",
          "Gain insights from TACTOS mentors & industry experts."
        ],
        [
          "Certification & Recognition",
          "Receive a certificate validating your leadership role."
        ],
      ].map(([title, desc], i,arr) => (
        <div
          key={i}
          className="relative w-full md:w-[32%] border p-6 rounded-xl bg-white shadow-sm"
        >
          <h3 className="text-xl font-bold mb-2">{title}</h3>
          <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

          {i !== arr.length - 1 && (
        <div
          className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
        ></div>
      )}
        </div>
      ))}
    </div>

    {/* Row 2 */}
    <div className="flex flex-col md:flex-row justify-center gap-6">
      {[
        [
          "Direct Access to Mentors",
          "Participate in mentorship sessions with leaders & founders."
        ],
        [
          "Join a National Network",
          "Connect with ambassadors across institutions nationwide."
        ],
        [
          "Lead State / Regional Initiatives",
          "Take charge of large-scale entrepreneurship initiatives."
        ],
      ].map(([title, desc], i,arr) => (
        <div
          key={i}
          className="relative w-full md:w-[32%] border p-6 rounded-xl bg-white shadow-sm"
        >
          <h3 className="text-xl font-bold mb-2">{title}</h3>
          <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

        {i !== arr.length - 1 && (
        <div
          className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
        ></div>
      )}
        </div>
      ))}
    </div>

  </div>
</section>


      {/* -------------------------------------- */}
      {/* WHY THIS PROGRAM */}
      {/* -------------------------------------- */}
      <section className="py-10 px-6 md:px-20 bg-gray-50">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 tracking-wide">
          WHY <span className="text-[#fd3e3d]">THIS PROGRAM?</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {[
            "To create student-led innovation communities",
            "To identify budding leaders in institutions",
            "To strengthen startup mindset inside colleges",
            "To build a national network of student innovators",
            "To give students real-world leadership experience",
            "To promote entrepreneurship among students",
          ].map((reason, i) => (
            <div
              key={i}
              className="flex items-center gap-5 border rounded-xl p-6 shadow-sm hover:shadow-md transition"
            >
              <div className="w-12 h-12 rounded-full bg-black text-white flex items-center justify-center font-bold">
                {i + 1}
              </div>
              <p className="text-gray-700">{reason}</p>
            </div>
          ))}
        </div>

        {/* APPLY CTA */}
        <div className="text-center mt-14">
          <button
           onClick={()=>setIsModalOpen(true)}
            className="inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-4 px-10 rounded-xl shadow-lg hover:shadow-xl transition"
          >
            Apply Now
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </section>


      {isModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    {/* BACKDROP */}
    <div
      className="absolute inset-0 bg-black/60 backdrop-blur-sm"
      onClick={() => setIsModalOpen(false)}
    />

    {/* MODAL */}
    <div className="relative w-full max-w-xl max-h-[98vh] rounded-2xl overflow-hidden shadow-2xl bg-white flex flex-col">

      {/* HEADER */}
      <div className="bg-black p-6 text-center relative shrink-0">
        <button
          onClick={() => setIsModalOpen(false)}
          className="absolute top-4 right-4 text-white/80 hover:text-white"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="flex justify-center mb-3">
          <div className="bg-[#fd3e3d] p-3 rounded-full">
            <Calendar className="w-8 h-8 text-white" />
          </div>
        </div>

        <h3 className="text-white text-2xl font-bold">
          Student Ambassador Application
        </h3>
      </div>

      {/* STEPPER */}
      <div className="px-6 py-6 shrink-0">
        <div className="flex items-center justify-between relative">
          <div className="absolute top-1/2 left-0 w-full h-[2px] bg-gray-300 -translate-y-1/2" />
          <div
            className="absolute top-1/2 left-0 h-[2px] bg-[#fd3e3d] -translate-y-1/2 transition-all duration-500"
            style={{ width: `${((currentStep - 1) / 3) * 100}%` }}
          />

          {[1, 2, 3, 4].map(step => (
            <div key={step} className="relative z-10">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold
                  ${currentStep >= step
                    ? "bg-[#fd3e3d] text-white scale-110"
                    : "bg-gray-200 text-gray-500"}`}
              >
                {step}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FORM (SCROLLABLE) */}
      <form className="flex-1 p-6 space-y-5 overflow-y-auto">

        {/* STEP 1 – BASIC INFORMATION */}
       {currentStep === 1 && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

    <div>
      <label className="text-sm text-black/70">Full Name</label>
      <input
        value={formData.name}
        onChange={e => setFormData({ ...formData, name: e.target.value })}
        placeholder="Full Name"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">Email</label>
      <input
        value={formData.email}
        onChange={e => setFormData({ ...formData, email: e.target.value })}
        placeholder="Email"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">Phone Number</label>
      <input
        value={formData.phone}
        onChange={e => setFormData({ ...formData, phone: e.target.value })}
        placeholder="Phone Number"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">College / University</label>
      <input
        value={formData.college}
        onChange={e => setFormData({ ...formData, college: e.target.value })}
        placeholder="College / University"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">City and State</label>
      <input
        value={formData.cityAndState}
        onChange={e => setFormData({ ...formData, cityAndState: e.target.value })}
        placeholder="City and State"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Program, Department and Year
      </label>
      <input
        value={formData.programDepartmentYear}
        onChange={e =>
          setFormData({ ...formData, programDepartmentYear: e.target.value })
        }
        placeholder="Program, Department & Year"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div className="md:col-span-2">
      <label className="text-sm text-black/70">Expected Graduation Year</label>
      <input
        value={formData.graduationYear}
        onChange={e =>
          setFormData({ ...formData, graduationYear: e.target.value })
        }
        placeholder="Expected Graduation Year"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

  </div>
)}


        {/* STEP 2 – STARTUP & LEADERSHIP */}
        {currentStep === 2 && (
  <div className="grid grid-cols-1 gap-4">

    <div>
      <label className="text-sm text-black/70">
        Are you a startup founder?
      </label>
      <select
        value={formData.isFounder}
        onChange={e => setFormData({ ...formData, isFounder: e.target.value })}
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Yes / No</option>
        <option>Yes</option>
        <option>No</option>
      </select>
    </div>

    <div>
      <label className="text-sm text-black/70">
        Entrepreneurial or Leadership Background
      </label>
      <textarea
        value={formData.leadershipBackground}
        onChange={e =>
          setFormData({ ...formData, leadershipBackground: e.target.value })
        }
        placeholder="Entrepreneurial or Leadership Background"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

  </div>
)}


        {/* STEP 3 – MOTIVATION & COMMITMENT */}
       {currentStep === 3 && (
  <div className="grid grid-cols-1 gap-4">

    <div>
      <label className="text-sm text-black/70">
        Why do you want to become a TACTOS Student Ambassador?
      </label>
      <textarea
        value={formData.whyAmbassador}
        onChange={e =>
          setFormData({ ...formData, whyAmbassador: e.target.value })
        }
        placeholder="Why do you want to become a TACTOS Student Ambassador?"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Will you act as the primary point of contact between TACTOS and your institution?
      </label>
      <select
        value={formData.primaryContact}
        onChange={e =>
          setFormData({ ...formData, primaryContact: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Yes / No</option>
        <option>Yes</option>
        <option>No</option>
      </select>
    </div>

    <div>
      <label className="text-sm text-black/70">
        Can you commit to this role for a minimum of six months?
      </label>
      <select
        value={formData.sixMonthCommitment}
        onChange={e =>
          setFormData({ ...formData, sixMonthCommitment: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Yes / No</option>
        <option>Yes</option>
        <option>No</option>
      </select>
    </div>

  </div>
)}


        {/* STEP 4 – LINKS & DECLARATION */}
       {currentStep === 4 && (
  <div className="space-y-4">

    <div>
      <label className="text-sm text-black/70">LinkedIn Profile</label>
      <input
        value={formData.linkedInProfile}
        onChange={e =>
          setFormData({ ...formData, linkedInProfile: e.target.value })
        }
        placeholder="LinkedIn Profile"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">CV Upload</label>
      <input
        type="file"
        onChange={e =>
          setFormData({ ...formData, cvFile: e.target.files[0] })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <label className="flex items-start gap-3 text-sm text-black/60">
      <input
        type="checkbox"
        checked={formData.declarationAccepted}
        onChange={e =>
          setFormData({ ...formData, declarationAccepted: e.target.checked })
        }
      />
      I confirm that the information provided is accurate and I agree to represent
      the TACTOS Student Ambassador Program responsibly.
    </label>

  </div>
)}


        {/* NAVIGATION */}
        <div className="flex justify-between pt-4">
          {currentStep > 1 && (
            <button
              type="button"
              onClick={() => setCurrentStep(s => s - 1)}
              className="px-4 py-2 border rounded-lg"
            >
              Back
            </button>
          )}

          <div className="ml-auto flex gap-3">
            {currentStep < 4 && (
              <button
                type="button"
                onClick={() => setCurrentStep(s => s + 1)}
                className="px-6 py-2 bg-[#fd3e3d] text-white rounded-lg"
              >
                Next
              </button>
            )}

            {currentStep === 4 && (
              <button
                type="button"
                onClick={handleSubmit}
                disabled={processing}
                className="px-6 py-2 bg-[#fd3e3d] text-white rounded-lg"
              >
               {processing?"Loading":"Submit"}
              </button>
            )}
          </div>
        </div>

      </form>
    </div>
  </div>
)}

    </>
  );
};

export default StudentAmbassoderPage;
